<script>
import SimpleTable from "@/view/order/extraFees/SimpleTable.vue";

export default {
  name: "Quotation",
  components: {SimpleTable},
  props: {
    type: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <SimpleTable :category="type" />
</template>

<style scoped>

</style>
